<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>
    <header class="sdev-topbar">
        <button class="sdev-topbar-toggle sdev-topbar-action" @click="$emit('toggleSidebar')">
            <BaseIcon name="dashBoard" class="sdev-color-primary" />
        </button>
        <div class="sdev-topbar-brand">
            <div class="sdev-brand-title">
                SDEV Solution <span class="sdev-brand-accent">Bedrock</span>
            </div>
            <div class="sdev-brand-sub">
                Platform for me
            </div>
        </div>
        <div class="sdev-topbar-actions">
            <!-- Logout fix rechts -->
            <button class="sdev-topbar-action" title="logout" aria-label="logout" @click="logoutUser">
                <BaseIcon name="logout" class="sdev-color-primary" />
            </button>
        </div>
    </header>
</template>
<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { logout } from "@/domain/auth/auth.service"

const router = useRouter();

/*
    Alle SVG-Dateien automatisch laden
*/
const modules = import.meta.glob(
    "@/assets/icons/*.svg",
    { eager: true }
);

/*
    Dateinamen extrahieren
    happyFace.svg → happyFace
*/
const actionIcons = computed(() => {
    return Object.keys(modules)
        .map(path => {
            const file = path.split("/").pop();
            return file.replace(".svg", "");
        })
        .filter(name => name !== "logout") // Logout separat behandeln
        .sort(); // optional alphabetisch
});

function logoutUser() {
    logout();
    router.replace({ path: "/login" });
}
</script>